import { render, staticRenderFns } from "./system-config.vue?vue&type=template&id=9a3d5ca2"
import script from "./system-config.vue?vue&type=script&lang=js"
export * from "./system-config.vue?vue&type=script&lang=js"
import style0 from "./system-config.vue?vue&type=style&index=0&id=9a3d5ca2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports